import { owcTheme } from 'core/theme/theme.config';

export const APP_HEADER_HEIGHT = '3rem';
export const APP_ROUTE_TRANSITION_BACKGROUND = `color-mix(in srgb, ${owcTheme['one-color-accent-white']} 88%, transparent)`;
export const APP_SIDE_MENU_WIDTH = '292px';
